<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :disablePage='disablePage'
      :current="page">
      <div slot="queryParams" class="form">
        <div class="queryContainer">
            <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

            <!-- <label>商品通用名:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.approvedName'></lk-input> -->
          </div>
          <div class="queryItem">
            <label>供应商名称:</label>
            <SupplierListSelect filterable v-model="query.supplierStoreId"></SupplierListSelect>
          </div>
          <div class="queryItem">
            <label>退货单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.purchaseRefundCode'></lk-input>
          </div>
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
             <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>验收单号:</label>
            <lk-input :maxlength='100' placeholder='请输入' class="item" clearable v-model.trim='query.inspectionCode'></lk-input>
          </div>
          <div class="queryItem">
            <label>审批状态:</label>
            <lk-select clearable class="item" v-model='query.status'>
              <lk-option v-for="item in approvalStatusList" :key="item.id" :value="item.id">
                {{item.name}}
              </lk-option>
            </lk-select>
          </div>

          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTimeStart' :options='createTimeStartOption' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.createTimeEnd' :options='createTimeEndOption' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>审批日期:</label>
            <timeStampDatePicker type="daterange" v-model='query.checkTimeRange' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>出库日期:</label>
            <timeStampDatePicker type="daterange" v-model='query.deliverTimeRange' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select class="item" v-model="query.purchaseType" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
         <div class="btn-wrap mb16">
            <lk-button class="mr8" type="primary" @click="addNew" v-if="handlePermission('supplierRefundAdd')">+创建退货单</lk-button>
            <DownloadButton class="mr8"  @on-click="downloadExcel" v-if="handlePermission('supplierRefundExcel')"></DownloadButton>
            <span v-if="true || this.handlePermission('printInspection')">
              <!-- <lk-button class="mr8" type="primary" @click="getPrintListData" :disabled="printSelected.length === 0">打印所选</lk-button> -->
              <lk-button class="mr8" type="primary" @click="printSetting">设置纸张</lk-button>
            </span>
         </div>


        <lk-table border :columns='columns' :data='tableData' @on-selection-change='handleSelectionChange'></lk-table>
      </div>
    </QueryFrame>
    <lk-modal v-model="printSettingVisiable" title="设置纸张" width='550'>
      <div class="modelContent">
        <div class="params">
          <lk-form
            :label-width='75'
            label-position="right"
          >
            <lk-row :gutter='16'>
              <lk-col span='8'>
                <lk-form-item label='纸张类型:'>
                  <lk-radio-group v-model="printPaperSize">
                    <lk-radio :label="8">二等分</lk-radio>
                    <lk-radio :label="5">三等分</lk-radio>
                  </lk-radio-group>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <div style="text-align: center;">
              <img width="450" src="../../assets/paperSize.png" alt="">
            </div>
          </lk-form>
        </div>
      </div>
      <div slot="footer">
        <lk-button @click="printSettingVisiable = false">取消</lk-button>
        <lk-button @click="confirmPrintSetting" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
    <lk-modal
      v-model="refundModal.isShowCancelRefund"
      title="提示"
      :footer-hide="true"
      @on-ok="toConfirmRefund"
    >
      <div style="font-size:16px;">是否确认取消退货？</div>
      <lk-input placeholder="请输入取消退货原因" v-model="refundModal.cancelReason" type="textarea" :maxlength="200" :rows="3"></lk-input>
      <div style="display:flex;justify-content:flex-end;margin-top:12px;">
        <lk-button @click="toConfirmRefund" type='primary'>确认</lk-button>
        <lk-button @click="toConcel" style="margin-left:12px;">取消</lk-button>
      </div>
    </lk-modal>
    <LinkQR029 ref="LinkQR029"></LinkQR029>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import refund from '../../services/refund';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import LinkQR029 from '../../components/print/LinkQR029';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'supplierRefundList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    LinkQR029,
    SupplierListSelect,
    DownloadButton,
  },
  data() {
    return {
      refundModal: {
        isShowCancelRefund: false,
        cancelReason: '',
        purchaseRefundId: '',
      },
      disablePage: false,
      approvalStatusList: [
        {
          id: 1,
          name: '草稿'
        },
        {
          id: 2,
          name: '审批中',
        },
        {
          id: 3,
          name: '已出库',
        },
        {
          id: 4,
          name: '已拒绝',
        },
        {
          id: 7,
          name: '取消中'
        },
        {
          id: 8,
          name: '待出库',
        },
        {
          id: 9,
          name: '已取消'
        },
      ],
      query: {
        supplierStoreId: null, // 供应商名称
        purchaseRefundCode: '', // 退货单号
        storeIdList: [], // 门店名称
        inspectionCode: '', // 验收单号
        status: '', // 审批状态 1草稿 2审核中 3审核通过 4审核未通过 （无状态） 6: 海典完成状态
        approvedName: '', // 商品名称
        createTimeStart: null, // 创建开始时间
        createTimeEnd: null, // 创建结束时间
        purchaseType: null, // 来源
        checkTimeRange: [], // 审批日期
        deliverTimeRange: [], // 出库日期
      },
      createTimeStartOption: this.createTimeStartOptions(),
      createTimeEndOption: this.createTimeEndOptions(),
      subColumns: [
        { title: '序号', type: 'index', minWidth: 80 },
        { title: '验收单号', key: 'inspectionCode', minWidth: 116 },
        { title: '入库时间', key: 'purchaseTime', minWidth: 116 },
        { title: '商品编码', key: 'serialCode', minWidth: 116 },
        { title: '通用名', key: 'approvedName', minWidth: 116 },
        { title: '商品名', key: 'goodsName', minWidth: 116 },
        { title: '规格', key: 'spec', minWidth: 116 },
        { title: '产地', key: 'origin', minWidth: 116 },
        { title: '生产厂家', key: 'producer', minWidth: 116 },
        { title: '批号', key: 'batchCode', minWidth: 116 }, // batchSeq 批次
        { title: '批次', key: 'batchSeq', minWidth: 116 },
        { title: '有效期', key: 'expiryDate', minWidth: 116 },
        { title: '包装单位', key: 'minPkgUnitName', minWidth: 116 },
        { title: '原验收数量', key: 'inspectionPassNum', minWidth: 116 },
        { title: '库存数量', key: 'inventoryTotalNum', minWidth: 116 },
        { title: '退货数量', key: 'num', minWidth: 116 },
        { title: '单价', key: 'refundPrice', minWidth: 116 },
        { title: '退货金额', key: 'amount', minWidth: 116 },
      ],
      columns: [
        // {
        //   type: 'selection',
        //   width: 60,
        //   align: 'center',
        //   fixed: 'left',
        // },
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h('lk-table', {
            props: {
              row: params.row,
              showExpandRow: true,
              data: params.row.purchaseRefundDetailList,
              columns: this.subColumns,
            },
          }),
        },
        // { title: '门店名称', key: 'purchaseRefundStoreName', minWidth: 116 },
        { title: '退货单号', key: 'purchaseRefundCode', minWidth: 116 },
        {
          title: '来源',
          key: 'purchaseRefundPurchaseTypeName',
          minWidth: 116,
          tooltip: true,
        },
        { title: '供应商名称', key: 'purchaseRefundSupplierName', minWidth: 116 },
        { title: '退货总金额', key: 'purchaseRefundAmount', minWidth: 116 },
        { title: '状态', key: 'purchaseRefundStatusName', minWidth: 116 },
        { title: '创建人', key: 'purchaseRefundCreateUserName', minWidth: 116 },
        { title: '创建时间', key: 'purchaseRefundCreateTime', minWidth: 116 },
        { title: '审批时间', key: 'purchaseRefundReviewTimeStr', minWidth: 116 },
        { title: '出库时间', key: 'purchaseRefundDeliveredTimeStr', minWidth: 116 },
        { title: '退货原因', key: 'purchaseRefundRemark', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          // fixed: 'right',
          width: 140,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.isSheetAble(params.row.purchaseRefundStatus) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'refundSheet', params: { id: params.row.purchaseRefundId } });
                },
              },
            }, '关联单据') : null,
            this.isEditAble(params.row.purchaseRefundStatus) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'supplierRefundEdit', params: { id: params.row.purchaseRefundId } });
                },
              },
            }, '编辑') : null,
            this.isDeleteAble(params.row.purchaseRefundStatus) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.handleRefundDelete(params.row.purchaseRefundId, params.index);
                },
              },
            }, '删除') : null,
            this.isPrintAble(params.row.purchaseRefundStatus) ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$refs.LinkQR029.handlePrint(params.row.purchaseRefundId, this.printPaperSize);
                },
              },
            }, '打印') : null,
            this.handlePermission('confirmDelivery') && [8].includes(params.row.purchaseRefundStatus) ? h('lk-button', { // 8：待出库状态显示该按钮
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '提示',
                    content: '<p>是否确认退货出库?</p>',
                    onOk: () => {
                      refund.confirmDelivery({ purchaseRefundId : params.row.purchaseRefundId }).then(res => {
                        if (res.data.status === 200) {
                          this.$Message.success('操作成功');
                          this.getData();
                        } else {
                          this.$Message.error(res.data.error);
                        }
                      }).catch(err => {
                        utils.handleError(err);
                      })
                    },
                  })
                }
              }
            }, '确认出库') : '',
            this.handlePermission('cancelDelivery') && [8].includes(params.row.purchaseRefundStatus) ? h('lk-button', { // 8：待出库状态显示该按钮
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.refundModal.purchaseRefundId = params.row.purchaseRefundId;
                  this.refundModal.isShowCancelRefund = true;
                }
              }
            }, '取消退货') : ''
          ]),
        },
      ],
      tableData: [],
      printSelected: [],
      printSettingVisiable: false,
      printPaperSize: 5,
    };
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
    ]),
  },
  methods: {
   toConfirmRefund() {
     if (!this.refundModal.cancelReason) {
       this.$Message.error('请填写取消退货原因');
       return
     }
     let { cancelReason, purchaseRefundId} = this.refundModal;
     const params = {
       purchaseRefundId,
       cancelReason
     }
     refund.cancelRefund(params).then(res => {
       this.refundModal.isShowCancelRefund = false;
       if (res.data.status === 200) {
         this.$Message.success('操作成功');
         this.getData();
       } else {
         this.$Message.error(res.data.error);
       }
     }).catch(err => {
       utils.handleError(err);
     })
   },
   toConcel() {
     this.refundModal.isShowCancelRefund = false;
   },
    printSetting() {
      this.printSettingVisiable = true;
    },
    confirmPrintSetting() {
      console.log(this.printPaperSize);
      localStorage.supplierRefundPrintSize = this.printPaperSize;
      this.printSettingVisiable = false;
      this.$Message.success('设置成功！');
    },
    handleSelectionChange(res) {
      console.log(res);
      this.printSelected = [];
      res.forEach((item) => {
        this.printSelected.push(item.purchaseRefundId);
      });
    },
    getPrintListData() {
      // this.printInspectionList(this.tempPrintIds);
    },
    // 清空检索项
    clear() {
      this.query = {};
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.params.checkTimeRange && this.params.checkTimeRange.length && ([this.params.reviewTimeStart, this.params.reviewTimeEnd] = this.params.checkTimeRange);
      this.params.deliverTimeRange && this.params.deliverTimeRange.length && ([this.params.deliveredTimeStart, this.params.deliveredTimeEnd] = this.params.deliverTimeRange);
      refund.refundList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.purchaseRefundCreateTime = utils.exchangeTime(result.purchaseRefundCreateTime); // 创建时间
            result._disabled = !this.isPrintAble(result.purchaseRefundStatus);
            result.purchaseRefundDetailList.forEach((subItem) => {
              subItem.expiryDate = utils.exchangeTime(subItem.expiryDate);
              subItem.purchaseTime = utils.exchangeTime(subItem.purchaseTime);
            });
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    addNew() {
      this.$router.push({ name: 'supplierRefundAdd' });
    },
    isSheetAble(status) {
      if ((status === 3 || status === 6) && this.handlePermission('refundSheet')) {
        return true;
      }
      return false;
    },
    // 是否可以修改 status 状态 1草稿 2审核中 3审核通过 4审核未通过 （无状态）6海典完成状态
    isEditAble(status) {
      if ((status === 1 || status === 4) && this.handlePermission('supplierRefundEdit')) {
        return true;
      }
      return false;
    },
    isDeleteAble(status) {
      if (status === 1 && this.handlePermission('supplierRefundDeleteBtn')) {
        return true;
      }
      return false;
    },
    isPrintAble(status) {
      // 3:已出库  6：审核通过 7：取消中 8：待出库
      if ([3, 6, 7, 8].includes(status) && this.handlePermission('supplierRefundPrint')) {
        return true;
      }
      return false;
    },
    // 删除退货单
    handleRefundDelete(purchaseRefundId) {
      this.$Modal.confirm({
        title: '确认',
        content: '<p>此操作将永久删除该数据，请确定是否要删除？</p>',
        onOk: () => {
          refund.purchaseRefundDelete({ purchaseRefundId }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('删除成功！');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        },
      });
    },
    createTimeStartOptions() {
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.createTimeEnd) {
            return time.getTime() > vm.query.createTimeEnd;// 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    createTimeEndOptions() {
      const vm = this;
      return {
        disabledDate(time) {
          if (vm.query.createTimeStart) {
            return time.getTime() < vm.query.createTimeStart;// 开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    downloadExcel() {
      const params = Object.assign({}, this.params);
      params.page = 0;
      params.size = 0;
      params.checkTimeRange && params.checkTimeRange.length && ([params.reviewTimeStart, params.reviewTimeEnd] = params.checkTimeRange);
      params.deliverTimeRange && params.deliverTimeRange.length && ([params.deliveredTimeStart, params.deliveredTimeEnd] = params.deliverTimeRange);
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      refund.downloadExcel(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    // this.getData();
    this.handleSearch(true);
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'purchaseRefundStoreName', minWidth: 116 });
    }
    if (localStorage.supplierRefundPrintSize) {
      this.printPaperSize = Number(localStorage.supplierRefundPrintSize);
    }
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 16px;
  >*{margin-right: 16px
}
}

</style>
